import { c as _c } from "react/compiler-runtime";
import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import SuperTitle from "@/components/common/supertitle/supertitle";
import Image from "@/components/common/image/image";
import imageUrl from "@/sanity/utilities/imageUrl";
import { Eligibility as EligibilityType } from "@/sanity/sanity.types";
import useBreakpoint from "@/hooks/useBreakpoint";
interface IEligibilityProps {
  data: EligibilityType;
}
const SmartUse = t0 => {
  const $ = _c(25);
  const {
    data
  } = t0;
  const {
    eyebrow,
    heading,
    subheading,
    items
  } = data;
  const {
    lg
  } = useBreakpoint();
  let t1;
  if ($[0] !== lg) {
    t1 = lg ? {
      gridColumn: "2 / span 10"
    } : undefined;
    $[0] = lg;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== eyebrow) {
    t2 = <SuperTitle>{eyebrow}</SuperTitle>;
    $[2] = eyebrow;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== heading) {
    t3 = <h2 className="mt-4 text-[#373A36]">{heading}</h2>;
    $[4] = heading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== subheading) {
    t4 = <p className="mt-4 max-w-[650px] text-[19px] leading-[29px] text-[#4A4A4A] lg:text-center">{subheading}</p>;
    $[6] = subheading;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="mb-8 flex flex-col lg:mb-10 lg:items-center lg:text-center">{t2}{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== items) {
    t6 = items?.map(_temp);
    $[12] = items;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <div className="hidden lg:block">{t6}</div>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== items) {
    t8 = items?.map(_temp2);
    $[16] = items;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <div className="lg:hidden">{t8}</div>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t5 || $[22] !== t7 || $[23] !== t9) {
    t10 = <GridRow className="!gap-y-12"><GridColumn lg={10} style={t1}>{t5}{t7}{t9}</GridColumn></GridRow>;
    $[20] = t1;
    $[21] = t5;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default SmartUse;
function _temp(item) {
  return <div key={item._key} className="flex border-b border-[#D9D8D6] py-6"><div className="flex w-[300px] shrink-0 items-center gap-8"><div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#F2F2F2]">{item.icon?.asset && <Image src={imageUrl(item.icon.asset).url()} alt={item.title ?? ""} width={28} height={28} />}</div><div className="text-[20px] font-semibold leading-[27px] text-[#373B37]">{item.title}</div></div><div className="flex-1 text-[16px] font-medium leading-[22px] text-[#4A4A4A]">{item.description}</div></div>;
}
function _temp2(item_0) {
  return <div key={item_0._key} className="flex gap-4 border-b border-[#D9D8D6] py-5"><div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#F2F2F2]">{item_0.icon?.asset && <Image src={imageUrl(item_0.icon.asset).url()} alt={item_0.title ?? ""} width={28} height={28} />}</div><div><h3 className="text-[20px] font-semibold leading-[24px] text-[#373A36]">{item_0.title}</h3><p className="mt-2 text-[16px] font-medium leading-[22px] text-[#4A4A4A]">{item_0.description}</p></div></div>;
}